import { Pipe, PipeTransform } from '@angular/core';
import { type HighlightedName, highlight } from '@shared/utils/highlight';

@Pipe({ name: 'highlight' })
export class HighlightPipe implements PipeTransform {
  transform(name: string, query: string): HighlightedName {
    return highlight(name, query);
  }
}
